import { useTranslation } from 'react-i18next'
import { Button } from 'antd'

import Link from 'components/atoms/Link'
import Title from 'components/atoms/Title'

export default function CompleteSendMail() {
  const { t } = useTranslation()

  return (
    <>
      <Title title="forgotPassword.forgotSuccessTitle" />

      <p className=" text-lg my-5">
        {t('forgotPassword.forgotSuccessSubTitle1')}
      </p>
      <p className=" text-lg my-5">
        {t('forgotPassword.forgotSuccessSubTitle2')}
      </p>

      <Link
        to="/signin"
        className="text-primary font-semibold flex justify-center underline"
      >
        <Button type="primary" block size="large">
          {t('forgotPassword.buttonBackSignin')}
        </Button>
      </Link>
    </>
  )
}
